module.exports = __webpack_public_path__ + "static/media/emo5a.886ecdcc.png";